<template>
  <inline-svg
    class="text-purple-500 fill-current"
    :src="require('assets/images/icons/loader.svg')"
  />
</template>
